export default "__VITE_ASSET__wCUNCDsb__"